__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-05-13-1778669175-stable-dev/";